export default __webpack_public_path__ + "static/media/Hismith.26d5eb1f.png";